import ReactDOM from 'react-dom';
import { RootProviders } from './root-providers';

/**
 * @param {React.SFCElement<any> | React.SFCElement<any>[]} children
 * @param {Element | DocumentFragment | null} attachedElement - `container` for `ReactDOM.render`
 * @param {() => void} callback
 * @param {import("@bamboohr/fabric/dist/styles/types").ThemeProviderProps} themeProps
 * @param {boolean} safe - Defaults to `false`. Set to `true` to exit early and avoid crashing if `attachedElement` (container) is falsy
 */
export const render = (
	children,
	attachedElement,
	callback,
	themeProps,
	safe = false,
) => {
	if (safe && !attachedElement) {
		console.error(
			"'attachedElement' provided to 'render' was 'null' or 'undefined'",
		);
		return;
	}

	ReactDOM.render(
		<RootProviders themeProps={themeProps}>{children}</RootProviders>,
		attachedElement,
		callback,
	);
};

export default {
	render,
};
